// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PanelMenuPresentationProps } from "@eisinc/MobiusOverrides/PanelMenu";
import { xBaseTheme } from "@eisinc/XDL/types";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        cssOverrides: {
            wrapper: css`
                display: block;
            `,
        },
        panelRowProps: {
            css: css`
                justify-content: flex-start;
            `,
        },
        closeButtonProps: {
            css: css`
                padding-right: 10px;
                margin-left: auto;
            `,
        },
        backButtonProps: {
            css: css`
                padding-left: 10px;
            `,
        },
    } as PanelMenuPresentationProps,
} as xBaseTheme["panelMenu"];
